export default {
  getCategoryList: '/auth/media/category/index',
  getCategoryDetail: '/auth/media/category/detail',
  getVideoList: '/auth/media/videos',
  getChannelList: '/auth/media/channel/index',
  getVideoDetail: '/auth/media/detail',
  getChannelDetail: '',
  getVideoOrder: '/auth/media/search/getEntryOrderList',
  getKs: '/auth/media/ks',
  getChannelOrder: '/auth/media/search/getChannelOrderList',
  parseUrl: '/auth/media/resolve/url',
  getMediaFilters: '/auth/media/filters',
  getRelatedWebinar: '/auth/media/relatedWebinar',
  getRelatedEvent: '/auth/media/relatedEvent',
  getRelatedTrend: '/auth/media/relatedTrend',
  getRelatedConcept: '/auth/media/relatedConcept'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/media.js